import React from 'react'
import { CollectionTable } from '..'

const Exhibitions = props => (
  <CollectionTable type="exhibition" history={props.history} />
)

export default Exhibitions
